import {
  Component,
  HostListener,
  computed,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { TabBarComponent } from '../tab-bar/tab-bar.component';
import { NavService, TabService } from '@core';

@Component({
  selector: 'app-shell',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, TabBarComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './shell.component.html',
})
export class ShellComponent {
  private readonly router = inject(Router);
  private readonly navService = inject(NavService);
  private readonly tabService = inject(TabService);

  readonly screenWidth = signal(typeof window !== 'undefined' ? window.innerWidth : 1024);
  readonly isMobile = computed(() => this.screenWidth() < 768);
  readonly drawerOpen = signal(false);
  readonly sidebarCollapsed = signal(true);

  @HostListener('window:resize')
  onResize(): void {
    this.screenWidth.set(window.innerWidth);
    if (window.innerWidth >= 768) this.drawerOpen.set(false);
  }

  constructor() {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe((event) => {
        const url = event.urlAfterRedirects.split('?')[0];
        const item = this.navService.findItemByRoute(url);
        if (item?.route) {
          this.tabService.openTab({ id: item.id, title: item.label, route: item.route });
        }
      });
  }

  toggleSidebarCollapse(): void {
    if (this.isMobile()) return;
    this.sidebarCollapsed.update((v) => !v);
  }
}
